// src/hooks/useValidateOrderLines.ts
import { useGenericMutation } from "./useGenericApi";
import { ProductValidationResponse } from "@shared/helpers/apis/productHelper";
import { validateOrderLines } from "@shared/helpers/validateOrderLines";

export const useValidateOrderLines = (options?: {
    onMutate?: (variables: string[]) => Promise<void> | void;
    onSuccess?: (data: ProductValidationResponse[]) => void;
    onError?: (error: unknown) => void;
    onSettled?: (data: ProductValidationResponse[] | undefined, error: unknown | null) => void;
}) => {
    return useGenericMutation<ProductValidationResponse[], unknown, string[]>(
        (itemNumbers) => validateOrderLines(itemNumbers),
        {
            onMutate: options?.onMutate,
            onSuccess: options?.onSuccess,
            onError: options?.onError,
            onSettled: options?.onSettled,
        }
    );
};
